import { Divider, TmdxAvatar } from '@ds';

export const ServiceWithoutCoordinatorCard = () => {
  return (
    <div className="flex flex-col items-center w-[318px] h-[120px] bg-base-80 rounded-2xl p-4 gap-4">
      <div className="flex flex-row gap-2">
        <TmdxAvatar radius="lg" size="xl" type="user" isBordered />
        <span className="text-base-5 text-l-m">Service without TX Center Coordinator</span>
      </div>
      <Divider className="bg-base-55" />
    </div>
  );
};
